import { TimelineLite, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import * as SFX from "Data/SoundEffect";
import * as VO from "Data/VoiceOver";
import * as Topics from "Data/Topics";
import Settings from "Data/Settings";
import { RestStopCompletePopupLayout } from "Layouts/RestStopCompletePopupLayout";
import { LayoutSprite } from "GameObjects/UI/LayoutSprite";
import { LayoutButton } from "GameObjects/UI/LayoutButton";
import { Text } from "GameObjects/UI/Text";
import { IRuntimeDuck } from "Data/GameState";
import { LayoutNineSliceSprite } from "GameObjects/UI/LayoutNineSliceSprite";
import { templateResources } from "Data/templateResources";
import { ResourceType } from "Data/ResourceType";
import { BadgePopupLayout } from "../Layouts/BadgePopupLayout";
import GameState from "../Data/GameState";
import { Application } from "Application";
import { LayoutBitmapText } from "GameObjects/UI/LayoutBitmapText";
import { DwellToggleButton } from "GameObjects/UI/DwellToggleButton";
import { MainMenu } from "States/MainMenu";
import { LoadScreen } from "States/LoadScreen";

export default class BadgePopup extends HLF.Popup implements ReturnType<typeof BadgePopupLayout> {
    public static readonly NAME = "BadgePopup";

    public readonly bg: LayoutSprite;
    public readonly homeButton: LayoutButton;
    public readonly badgeBg: LayoutSprite[];
    public readonly badgeIconDodger: LayoutSprite[];
    public readonly badgeIconFirstFlight: LayoutSprite[];
    public readonly badgeIconFrequentFlyer: LayoutSprite[];
    public readonly badgeIconMeetTheDucks: LayoutSprite[];
    public readonly badgeIconPerfectPond: LayoutSprite[];
    public readonly badgeIconSwaptastic: LayoutSprite[];
    public readonly continueButton: LayoutButton;
    public readonly badge1Description: LayoutBitmapText;
    public readonly badge2Description: LayoutBitmapText;
    public readonly badge3Description: LayoutBitmapText;
    public readonly dwellToggleButton: DwellToggleButton = new DwellToggleButton();
    protected dwellToggleButtonRightMargin: number = 0;
    protected homeButtonLeftMargin: number = 0;

    private readonly badgeDescription: LayoutBitmapText[];

    private readonly badgeNames: string[] = new Array<string>(3);
    private readonly badgeNameVos: string[] = new Array<string>(3);
    private readonly badgeDescriptionVos: string[] = new Array<string>(3)

    private readonly badgeGroup: PIXI.Container[];

    public constructor() {
        super();
        this.bg = new LayoutSprite();

        this.badgeGroup = [
            new PIXI.Container(),
            new PIXI.Container(),
            new PIXI.Container(),
        ];

        this.badgeBg = [
            new LayoutSprite(),
            new LayoutSprite(),
            new LayoutSprite(),
        ];
        this.badgeIconDodger = [
            new LayoutSprite(),
            new LayoutSprite(),
            new LayoutSprite(),
        ];
        this.badgeIconFirstFlight = [
            new LayoutSprite(),
            new LayoutSprite(),
            new LayoutSprite(),
        ];
        this.badgeIconFrequentFlyer = [
            new LayoutSprite(),
            new LayoutSprite(),
            new LayoutSprite(),
        ];
        this.badgeIconMeetTheDucks = [
            new LayoutSprite(),
            new LayoutSprite(),
            new LayoutSprite(),
        ];
        this.badgeIconPerfectPond = [
            new LayoutSprite(),
            new LayoutSprite(),
            new LayoutSprite(),
        ];
        this.badgeIconSwaptastic = [
            new LayoutSprite(),
            new LayoutSprite(),
            new LayoutSprite(),
        ];
        this.continueButton = new LayoutButton(this.onContinueButtonClicked.bind(this), VO.DONE, SFX.UI_CLICK);
        this.badge1Description = new LayoutBitmapText("Badge Three", {fontName: Constants.FONT_RIFFICFREE_BOLD_36, tint: 0xffffff, align: "center"});
        this.badge2Description = new LayoutBitmapText("Badge Three", {fontName: Constants.FONT_RIFFICFREE_BOLD_36, tint: 0xffffff, align: "center"});
        this.badge3Description = new LayoutBitmapText("Badge Three", {fontName: Constants.FONT_RIFFICFREE_BOLD_36, tint: 0xffffff, align: "center"});
        this.badgeDescription = [
            this.badge1Description,
            this.badge2Description,
            this.badge3Description,
        ];
        this.homeButton = new LayoutButton(this.onHomeButtonPressed.bind(this), VO.HOME_BUTTON_HOVER, SFX.UI_CLICK);
    }

    public init(pSize: PIXI.Point) {
        BadgePopupLayout.call(this);
        this.addChild(this.bg);
        this.addChild(this.homeButton);

        this.badgeGroup.forEach((e, i) => {
            e.addChild(this.badgeBg[i]);
            e.addChild(this.badgeIconDodger[i]);
            e.addChild(this.badgeIconFirstFlight[i]);
            e.addChild(this.badgeIconFrequentFlyer[i]);
            e.addChild(this.badgeIconMeetTheDucks[i]);
            e.addChild(this.badgeIconPerfectPond[i]);
            e.addChild(this.badgeIconSwaptastic[i]);
            e.addChild(this.badgeDescription[i]);
            this.badgeDescription[i].position.x = this.badgeBg[i].position.x;
            this.badgeDescription[i].anchor = new PIXI.Point(0.5, 0);
            this.badgeDescription[i].fontSize *= Settings.textSizeMultiplier;
            this.addChild(e);
        });

        this.addChild(this.continueButton);
        this.addChild(this.dwellToggleButton);
        this.dwellToggleButtonRightMargin = 1024 - this.dwellToggleButton.x;
        const titleText = this.addChild(new Text("GREAT JOB!", Constants.FONT_RIFFICFREE_BOLD_36, 56, new PIXI.Point(0.5, 0.5)));
        titleText.position.x = 512;
        titleText.position.y = 384 - this.bg.height / 2;
        super.init(pSize); // calls onresize
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.position.set(-1024 / 2, -768 / 2);
        this.dwellToggleButton.position.x = -((pSize.x - 1024) / 2) + pSize.x - this.dwellToggleButtonRightMargin;
        this.homeButton.position.x = -((pSize.x - 1024) / 2) + this.homeButtonLeftMargin;
    }

    public show(pToken: HLF.IPopupToken) {
        super.show(pToken);
        console.log(pToken.data);
        if (pToken.data?.firstTime === true) {
            this.continueButton.pulse();
        }

        let badgesEarned = 0;

        this.badgeBg[0].visible = false;
        this.badgeBg[1].visible = false;
        this.badgeBg[2].visible = false;

        this.badgeDescription[0].visible = false;
        this.badgeDescription[1].visible = false;
        this.badgeDescription[2].visible = false;

        this.badgeIconDodger.forEach(icon=>icon.visible = false);
        this.badgeIconFirstFlight.forEach(icon=>icon.visible = false);
        this.badgeIconFrequentFlyer.forEach(icon=>icon.visible = false);
        this.badgeIconMeetTheDucks.forEach(icon=>icon.visible = false);
        this.badgeIconPerfectPond.forEach(icon=>icon.visible = false);
        this.badgeIconSwaptastic.forEach(icon=>icon.visible = false);

        if (GameState.flightCount === 1) {
            this.badgeDescription[badgesEarned % 3].text = "You finished your first flight!";
            this.badgeDescription[badgesEarned % 3].visible = true;
            this.badgeBg[badgesEarned % 3].setLayoutTexture("cyberchase-badges-gold", 0.5, 0.5);
            this.badgeBg[badgesEarned % 3].visible = true;
            this.badgeIconDodger[badgesEarned % 3].visible = false;
            this.badgeIconFirstFlight[badgesEarned % 3].visible = true;
            this.badgeIconFrequentFlyer[badgesEarned % 3].visible = false;
            this.badgeIconMeetTheDucks[badgesEarned % 3].visible = false;
            this.badgeIconPerfectPond[badgesEarned % 3].visible = false;
            this.badgeIconSwaptastic[badgesEarned % 3].visible = false;
            this.badgeNames[badgesEarned % 3] = "First Flight";
            this.badgeNameVos[badgesEarned % 3] = VO.BADGE_NAME_1;
            this.badgeDescriptionVos[badgesEarned % 3] = VO.BADGE_DESC_1;
            badgesEarned++;
        }
        else if (GameState.flightCount === 5) {
            this.badgeDescription[badgesEarned % 3].text = "Complete 5 flights";
            this.badgeDescription[badgesEarned % 3].visible = true;
            this.badgeBg[badgesEarned % 3].setLayoutTexture("cyberchase-badges-bronze", 0.5, 0.5);
            this.badgeBg[badgesEarned % 3].visible = true;
            this.badgeIconDodger[badgesEarned % 3].visible = false;
            this.badgeIconFirstFlight[badgesEarned % 3].visible = false;
            this.badgeIconFrequentFlyer[badgesEarned % 3].visible = true;
            this.badgeIconMeetTheDucks[badgesEarned % 3].visible = false;
            this.badgeIconPerfectPond[badgesEarned % 3].visible = false;
            this.badgeIconSwaptastic[badgesEarned % 3].visible = false;
            this.badgeNames[badgesEarned % 3] = "Frequent Flyer";
            this.badgeNameVos[badgesEarned % 3] = VO.BADGE_NAME_3;
            this.badgeDescriptionVos[badgesEarned % 3] = VO.BADGE_DESC_3A; // TODO: number substitution
            badgesEarned++;
        }
        else if (GameState.flightCount === 10) {
            this.badgeDescription[badgesEarned % 3].text = "Complete 10 flights";
            this.badgeDescription[badgesEarned % 3].visible = true;
            this.badgeBg[badgesEarned % 3].setLayoutTexture("cyberchase-badges-silver", 0.5, 0.5);
            this.badgeBg[badgesEarned % 3].visible = true;
            this.badgeIconDodger[badgesEarned % 3].visible = false;
            this.badgeIconFirstFlight[badgesEarned % 3].visible = false;
            this.badgeIconFrequentFlyer[badgesEarned % 3].visible = true;
            this.badgeIconMeetTheDucks[badgesEarned % 3].visible = false;
            this.badgeIconPerfectPond[badgesEarned % 3].visible = false;
            this.badgeIconSwaptastic[badgesEarned % 3].visible = false;
            this.badgeNames[badgesEarned % 3] = "Frequent Flyer";
            this.badgeNameVos[badgesEarned % 3] = VO.BADGE_NAME_3;
            this.badgeDescriptionVos[badgesEarned % 3] = VO.BADGE_DESC_3A; // TODO: number substitution
            badgesEarned++;
        }
        else if (GameState.flightCount === 20) {
            this.badgeDescription[badgesEarned % 3].text = "Complete 20 flights";
            this.badgeDescription[badgesEarned % 3].visible = true;
            this.badgeBg[badgesEarned % 3].setLayoutTexture("cyberchase-badges-gold", 0.5, 0.5);
            this.badgeBg[badgesEarned % 3].visible = true;
            this.badgeIconDodger[badgesEarned % 3].visible = false;
            this.badgeIconFirstFlight[badgesEarned % 3].visible = false;
            this.badgeIconFrequentFlyer[badgesEarned % 3].visible = true;
            this.badgeIconMeetTheDucks[badgesEarned % 3].visible = false;
            this.badgeIconPerfectPond[badgesEarned % 3].visible = false;
            this.badgeIconSwaptastic[badgesEarned % 3].visible = false;
            this.badgeNames[badgesEarned % 3] = "Frequent Flyer";
            this.badgeNameVos[badgesEarned % 3] = VO.BADGE_NAME_3;
            this.badgeDescriptionVos[badgesEarned % 3] = VO.BADGE_DESC_3A; // TODO: number substitution
            badgesEarned++;
        }

        if (GameState.dodgedAllObstacles === true) {
            if (pToken.data?.ducksCount === 5) {
                this.badgeDescription[badgesEarned % 3].text = "You dodged every obstacle with 5 ducks.";
                this.badgeDescription[badgesEarned % 3].visible = true;
                this.badgeBg[badgesEarned % 3].setLayoutTexture("cyberchase-badges-bronze", 0.5, 0.5);
                this.badgeBg[badgesEarned % 3].visible = true;
                this.badgeIconDodger[badgesEarned % 3].visible = true;
                this.badgeIconFirstFlight[badgesEarned % 3].visible = false;
                this.badgeIconFrequentFlyer[badgesEarned % 3].visible = false;
                this.badgeIconMeetTheDucks[badgesEarned % 3].visible = false;
                this.badgeIconPerfectPond[badgesEarned % 3].visible = false;
                this.badgeIconSwaptastic[badgesEarned % 3].visible = false;
                this.badgeNames[badgesEarned % 3] = "Great Dodger";
                this.badgeNameVos[badgesEarned % 3] = VO.BADGE_NAME_2;
                this.badgeDescriptionVos[badgesEarned % 3] = VO.BADGE_DESC_2;
                badgesEarned++;
            }
            else if (pToken.data?.ducksCount === 7) {
                this.badgeDescription[badgesEarned % 3].text = "You dodged every obstacle with 7 ducks.";
                this.badgeDescription[badgesEarned % 3].visible = true;
                this.badgeBg[badgesEarned % 3].setLayoutTexture("cyberchase-badges-silver", 0.5, 0.5);
                this.badgeBg[badgesEarned % 3].visible = true;
                this.badgeIconDodger[badgesEarned % 3].visible = true;
                this.badgeIconFirstFlight[badgesEarned % 3].visible = false;
                this.badgeIconFrequentFlyer[badgesEarned % 3].visible = false;
                this.badgeIconMeetTheDucks[badgesEarned % 3].visible = false;
                this.badgeIconPerfectPond[badgesEarned % 3].visible = false;
                this.badgeIconSwaptastic[badgesEarned % 3].visible = false;
                this.badgeNames[badgesEarned % 3] = "Great Dodger";
                this.badgeNameVos[badgesEarned % 3] = VO.BADGE_NAME_2;
                this.badgeDescriptionVos[badgesEarned % 3] = VO.BADGE_DESC_2;
                badgesEarned++;
            }
            else if (pToken.data?.ducksCount === 9) {
                this.badgeDescription[badgesEarned % 3].text = "You dodged every obstacle with 9 ducks.";
                this.badgeDescription[badgesEarned % 3].visible = true;
                this.badgeBg[badgesEarned % 3].setLayoutTexture("cyberchase-badges-gold", 0.5, 0.5);
                this.badgeBg[badgesEarned % 3].visible = true;
                this.badgeIconDodger[badgesEarned % 3].visible = true;
                this.badgeIconFirstFlight[badgesEarned % 3].visible = false;
                this.badgeIconFrequentFlyer[badgesEarned % 3].visible = false;
                this.badgeIconMeetTheDucks[badgesEarned % 3].visible = false;
                this.badgeIconPerfectPond[badgesEarned % 3].visible = false;
                this.badgeIconSwaptastic[badgesEarned % 3].visible = false;
                this.badgeNames[badgesEarned % 3] = "Great Dodger";
                this.badgeNameVos[badgesEarned % 3] = VO.BADGE_NAME_2;
                this.badgeDescriptionVos[badgesEarned % 3] = VO.BADGE_DESC_2;
                badgesEarned++;
            }
        }

        if (GameState.perfectPonds === true) {
            this.badgeDescription[badgesEarned % 3].text = "You chose all the best ponds!";
            this.badgeDescription[badgesEarned % 3].visible = true;
            this.badgeBg[badgesEarned % 3].setLayoutTexture("cyberchase-badges-gold", 0.5, 0.5);
            this.badgeBg[badgesEarned % 3].visible = true;
            this.badgeIconDodger[badgesEarned % 3].visible = false;
            this.badgeIconFirstFlight[badgesEarned % 3].visible = false;
            this.badgeIconFrequentFlyer[badgesEarned % 3].visible = false;
            this.badgeIconMeetTheDucks[badgesEarned % 3].visible = false;
            this.badgeIconPerfectPond[badgesEarned % 3].visible = true;
            this.badgeIconSwaptastic[badgesEarned % 3].visible = false;
            this.badgeNames[badgesEarned % 3] = "Perfect Ponds";
            this.badgeNameVos[badgesEarned % 3] = VO.BADGE_NAME_6;
            this.badgeDescriptionVos[badgesEarned % 3] = VO.BADGE_DESC_6;
            badgesEarned++;
        }

        if (GameState.swaptastic === true) {
            this.badgeDescription[badgesEarned % 3].text = "You chose all the best ducks to swap!";
            this.badgeDescription[badgesEarned % 3].visible = true;
            this.badgeBg[badgesEarned % 3].setLayoutTexture("cyberchase-badges-gold", 0.5, 0.5);
            this.badgeBg[badgesEarned % 3].visible = true;
            this.badgeIconDodger[badgesEarned % 3].visible = false;
            this.badgeIconFirstFlight[badgesEarned % 3].visible = false;
            this.badgeIconFrequentFlyer[badgesEarned % 3].visible = false;
            this.badgeIconMeetTheDucks[badgesEarned % 3].visible = false;
            this.badgeIconPerfectPond[badgesEarned % 3].visible = false;
            this.badgeIconSwaptastic[badgesEarned % 3].visible = true;
            this.badgeNames[badgesEarned % 3] = "Swaptastic";
            this.badgeNameVos[badgesEarned % 3] = VO.BADGE_NAME_5;
            this.badgeDescriptionVos[badgesEarned % 3] = VO.BADGE_DESC_5;
            badgesEarned++;
        }

        if (GameState.metAllTheDucks === true) {
            this.badgeDescription[badgesEarned % 3].text = "You met all 28 ducks!";
            this.badgeDescription[badgesEarned % 3].visible = true;
            this.badgeBg[badgesEarned % 3].setLayoutTexture("cyberchase-badges-gold", 0.5, 0.5);
            this.badgeBg[badgesEarned % 3].visible = true;
            this.badgeIconDodger[badgesEarned % 3].visible = false;
            this.badgeIconFirstFlight[badgesEarned % 3].visible = false;
            this.badgeIconFrequentFlyer[badgesEarned % 3].visible = false;
            this.badgeIconMeetTheDucks[badgesEarned % 3].visible = true;
            this.badgeIconPerfectPond[badgesEarned % 3].visible = false;
            this.badgeIconSwaptastic[badgesEarned % 3].visible = false;
            this.badgeNames[badgesEarned % 3] = "Meet the Ducks";
            this.badgeNameVos[badgesEarned % 3] = VO.BADGE_NAME_4;
            this.badgeDescriptionVos[badgesEarned % 3] = VO.BADGE_DESC_4;
            badgesEarned++;
        }

        // TODO: all of the vos in this block get interrupted before they are heard
        if (badgesEarned === 1) {
            this.badgeGroup[0].x = this.badgeBg[1].x - this.badgeBg[0].x;
            Application.instance.voiceover.playVO(VO.REWARD_ONE_BADGE, HLF.PlayMode.Append);
        }
        else if (badgesEarned === 0) {
            Application.instance.voiceover.playVO(VO.REWARD_NO_BADGES, HLF.PlayMode.Append);
        }
        else {
            if (badgesEarned === 2) {
                this.badgeGroup[0].x = (this.badgeBg[1].x - this.badgeBg[0].x) / 2;
                this.badgeGroup[1].x = (this.badgeBg[1].x - this.badgeBg[0].x) / 2;
            }
            Application.instance.voiceover.playVO(VO.REWARD_MULTIPLE_BADGES, HLF.PlayMode.Append);
        }

        const arraysOfThingsToAnimate: (LayoutSprite | LayoutBitmapText)[][] = [
            this.badgeBg,
            this.badgeDescription,
            this.badgeIconDodger,
            this.badgeIconFirstFlight,
            this.badgeIconFrequentFlyer,
            this.badgeIconMeetTheDucks,
            this.badgeIconPerfectPond,
            this.badgeIconSwaptastic,
        ];

        arraysOfThingsToAnimate.forEach(arr=>arr.forEach(el=>el.alpha = 0));
        const reactionVOs = [VO.BADGE_REACT_A, VO.BADGE_REACT_B, VO.BADGE_REACT_C, VO.BADGE_REACT_D]
        HLF.ArrayUtils.shuffle(reactionVOs);

        const animateInBadge = (i: number, cb: ()=>void)=>{
            HLF.Application.instance.voiceover.playVO(reactionVOs[i], ()=>{
                HLF.Application.instance.voiceover.playVO([
                    VO.BADGE_REACT_2A,
                    this.badgeNameVos[i],
                    VO.BADGE_REACT_2B,
                ], {mode: HLF.PlayMode.Append, caption: {
                    id: VO.BADGE_REACT_2A,
                    args: {
                        "BADGE": this.badgeNameVos[i],
                        "_": VO.BADGE_REACT_2B, // hack to extend duration of caption
                    },
                }});
                HLF.Application.instance.voiceover.playVO(this.badgeDescriptionVos[i], HLF.PlayMode.Append, cb);
            });
            new TimelineLite()
                .to(arraysOfThingsToAnimate.map(arr=>arr[i]), 0.5, {pixi: {alpha: 1}})
            HLF.Application.instance.audio.play(SFX.BADGE, 1, false, HLF.AudioCategory.SFX);
        }

        if (badgesEarned > 0) {
            animateInBadge(0, ()=>{
                if (badgesEarned > 1) {
                    animateInBadge(1, ()=>{
                        if (badgesEarned > 2) {
                            animateInBadge(2, ()=>{
                                if (Settings.audioDescriptionEnabled) {
                                    HLF.Application.instance.voiceover.playVO(VO.REST_STOP_AUDIO_DESCRIPTION_CONTINUE, HLF.PlayMode.Append);
                                }
                            });
                        }
                        else {
                            if (Settings.audioDescriptionEnabled) {
                                HLF.Application.instance.voiceover.playVO(VO.REST_STOP_AUDIO_DESCRIPTION_CONTINUE, HLF.PlayMode.Append);
                            }
                        }
                    })
                }
                else {
                    if (Settings.audioDescriptionEnabled) {
                        HLF.Application.instance.voiceover.playVO(VO.REST_STOP_AUDIO_DESCRIPTION_CONTINUE, HLF.PlayMode.Append);
                    }
                }
            });
        }
        else {
            if (Settings.audioDescriptionEnabled) {
                HLF.Application.instance.voiceover.playVO(VO.REST_STOP_AUDIO_DESCRIPTION_CONTINUE, HLF.PlayMode.Append);
            }
        }
    }

    public gotoNextState(name: string, data?: object) {
        HLF.Application.instance.voiceover.stopVO();
        PubSub.publishSync(HLF.STOP_CAPTION);
        PubSub.publishSync(HLF.UNREGISTER_ALL_FOCUSABLES);
        const steps = [
            HLF.TransitionStep.AnimCurrentOut,
            HLF.TransitionStep.ShowLoadScreen,
            HLF.TransitionStep.RemoveCurrent,
            HLF.TransitionStep.UnloadAssets,
            HLF.TransitionStep.LoadAssets,
            HLF.TransitionStep.AttachNewBehind,
            HLF.TransitionStep.AnimNewIn,
            HLF.TransitionStep.HideLoadScreen,
        ];
        PubSub.publishSync(
            HLF.STATE_LOAD_STATE, data ?
                new HLF.StateToken({id: name, data: {name, ...data}}, LoadScreen.NAME, ...steps) :
                new HLF.StateToken({id: name, data: {name}}, LoadScreen.NAME, ...steps),
        );
        this._callback = undefined;
        this.hide();
    }

    protected onHomeButtonPressed(): void {
        this.gotoNextState(MainMenu.NAME);
    }

    protected AnimateIn(pCallback: () => void): void {
        PubSub.publishSync(HLF.PUSH_KEYBOARD_LAYER);
        PubSub.publishSync(HLF.REGISTER_FOCUSABLES, [
            this.continueButton,
            this.homeButton,
        ]);
        TweenLite.fromTo(this, 0.5, {pixi: {alpha: 0}}, {pixi: {alpha: 1}}).eventCallback(Constants.TWEEN_ONCOMPLETE, pCallback);
    }

    protected AnimateOut(pCallback: () => void): void {
        PubSub.publishSync(HLF.POP_KEYBOARD_LAYER);
        TweenLite.to(this, 0.5, {pixi: {alpha: 0}}).eventCallback(Constants.TWEEN_ONCOMPLETE, pCallback);
    }

    protected onContinueButtonClicked() {
        this.continueButton.stopPulse();
        this.hide();
    }
}